import { useContext } from 'react';
import PracovnyKrokLegislativnyMaterialContext, {
  PracovnyKrokLegislativnyMaterialContextContent,
} from '../PracovnyKrokLegislativnyMaterialContext';

export default ():
  PracovnyKrokLegislativnyMaterialContextContent => useContext(PracovnyKrokLegislativnyMaterialContext);
